import { useEffect, useState } from 'react';
import deburr from 'lodash/deburr';
import {
  LICENSE_TYPE_CONFIG,
  LICENSE_TYPE_KEYS,
  getNextPaymentDate
} from '../services/contributor.service';
import { filterNotAllContributors } from '../../ContributorsAndTeams.service';

const useContributor = ({ currentTeams, contributors, license }) => {
  const [teamMembers, setTeamMembers] = useState(null);
  const [filteredTeamMembers, setFilteredTeamMembers] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [isNotInTeamSelected, setIsNotInTeamSelected] = useState(false);
  const [isInTeamSelected, setIsInTeamSelected] = useState(false);

  const { licenseType, startDate } = license;
  const licenseConfig = LICENSE_TYPE_CONFIG[LICENSE_TYPE_KEYS[licenseType]];
  const licenseNextPaymentDate = getNextPaymentDate(startDate);

  useEffect(() => {
    if (!currentTeams || !contributors) return;

    const teamMembers = contributors
      .map(({ email, id, name, username, created_at, extended_data }) => {
        const teams = currentTeams.filter(({ contributor_ids }) =>
          contributor_ids.includes(id)
        );

        return teams.length
          ? {
              email,
              id,
              name,
              username,
              extended_data,
              teams,
              added: created_at
            }
          : undefined;
      })
      .filter(Boolean);

    setTeamMembers(teamMembers);
    setFilteredTeamMembers(teamMembers);
  }, [currentTeams, contributors]);

  useEffect(() => {
    if (teamMembers === null) return;

    let filteredTeamMemers = teamMembers.filter(({ teams }) => {
      const isInNotInTeam =
        teams.length === 1 && filterNotAllContributors(teams).length;

      if (isNotInTeamSelected) {
        return isInNotInTeam;
      }

      if (isInTeamSelected) {
        return !isInNotInTeam;
      }

      return true;
    });

    filteredTeamMemers = filteredTeamMemers.filter(({ name, email }) =>
      searchTerm
        ? deburr(name ? name : '')
            .toLowerCase()
            .includes(deburr(searchTerm).toLowerCase()) ||
          (email ? email : '').toLowerCase().includes(searchTerm.toLowerCase())
        : true
    );

    setFilteredTeamMembers(filteredTeamMemers);
  }, [searchTerm, isNotInTeamSelected, isInTeamSelected]);

  return {
    filteredTeamMembers,
    teamMembers,
    setSearchTerm,
    licenseConfig,
    licenseNextPaymentDate,
    isNotInTeamSelected,
    setIsNotInTeamSelected,
    isInTeamSelected,
    setIsInTeamSelected
  };
};

export default useContributor;
